import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import { ReactComponent as CustomIcon } from './raw/np_comment_1591791_000000.svg';

const BBIconConstructionTie = (props) => {
    const {style, className} = props;
    return <SvgIcon
        component={CustomIcon}
        viewBox="0 0 100 100"
        style={style}
        className={className}
    />
}

export default BBIconConstructionTie;